<template>
    <div>
        <div id="chart"></div>
        <div class="table-header">
            <h2>详细数据</h2>
            <button class="export-btn" @click="exportExcel">导出EXCEL</button>
        </div>
        <vxe-table
            border
            highlight-hover-row
            ref="xTable"
            :data="table_data"
            :row-class-name="getRowClassName"
        >
            <vxe-table-column
                v-for="column in table_columns"
                :key="column.field"
                :field="column.field"
                :title="column.name"
                sortable
            >
            </vxe-table-column>
        </vxe-table>
    </div>
</template>
<script>
import { Chart } from '@antv/g2'
import { DATA_KEYS } from './_data_select'
import XLSX from 'xlsx'
let chart
export default {
    props: {
        building_data_items: Array,
        data_types: Array
    },
    beforeDestroy () {
        chart = null
    },
    mounted () {
        this.$nextTick(this.initChart)
    },
    computed: {
        show_chart () {
            return this.building_data_items && this.building_data_items.length && this.data_types && this.data_types.length
        },
        table_columns () {
            const columns = [{
                name: '日期',
                field: 'date'
            }]
            const data_types = this.data_types.map((name) => {
                return {
                    name,
                    field: DATA_KEYS[name]
                }
            })
            columns.push(...data_types)
            return columns
        },
        table_data () {
            const data = []
            if (this.building_data_items.length > 1) {
                const first = this.building_data_items[0]
                const last = this.building_data_items[this.building_data_items.length - 1]
                data.push({
                    is_total: true,
                    date: `${first.date}-${last.date}`,
                    ...this.data_types.reduce((obj, name) => {
                        const key = DATA_KEYS[name]
                        obj[key] = this.building_data_items.reduce((sum, item) => {
                            sum += item[key]
                            return sum
                        }, 0)
                        return obj
                    }, {})
                })
            }
            data.push(...this.building_data_items)
            return data
        }
    },
    watch: {
        building_data_items () {
            this.$nextTick(this.initChart)
        },
        data_types () {
            this.$nextTick(this.initChart)
        }
    },
    methods: {
        initChart () {
            if (!chart) {
                const c = new Chart({
                    container: 'chart',
                    autoFit: true,
                    visible: true,
                    limitInPlot: false
                })
                chart = c.createView()
            }
            const chart_data = this.building_data_items.reduce((prev, item) => {
                const items = this.data_types.map((name) => {
                    const key = DATA_KEYS[name]
                    return {
                        date: item.date.substring(5),
                        value: item[key],
                        name
                    }
                })
                prev.push(...items)
                return prev
            }, [])
            console.error('chart_data', chart_data)
            chart.data(chart_data)
            chart.tooltip({
                showCrosshairs: true,
                shared: true
            })
            chart.axis('value', {
                position: 'left',
                label: {
                    formatter: (val) => {
                        return val
                    }
                },
                verticalLimitLength: 100
            })
            chart
                .line()
                .position('date*value')
                .color('name')
                .shape('smooth')
            chart.render()
        },
        exportExcel () {
            const header = document.querySelector('.vxe-table--header thead');
            const body = document.querySelector('.vxe-table--body tbody');
            const table = document.createElement('table')
            table.innerHTML = header.innerHTML + body.innerHTML
            const wb = XLSX.utils.table_to_book(table, {sheet:"Sheet JS"});
            XLSX.writeFile(wb, '楼盘数据.xlsx')
        },
        getRowClassName ({ row }) {
            if (row.is_total) {
                return 'total-row'
            }
        }
    }
}
</script>
<style lang="scss" scoped>
#chart {
    margin: 24px 0;
    height: 300px;
}
</style>>
